// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProposalFile } from './proposalFile.zod.ts';
import { ProposalGap } from './proposalGap.zod.ts';
import { RefineChange } from './refineChange.zod.ts';

export const RefineProposalOut = zod.object({
  "asset_id": zod.uuid(),
  "base_revision": zod.int(),
  "changes": zod.array(RefineChange),
  "created_at": zod.iso.datetime({"offset":true}),
  "cut": zod.boolean(),
  "files": zod.array(ProposalFile),
  "gaps": zod.array(ProposalGap),
  "id": zod.uuid(),
  "industry_suggestions": zod.array(zod.string()),
  "instruction": zod.string(),
  "kind": zod.enum(['platform', 'accelerator', 'framework', 'offer']),
  "mode": zod.literal("refine"),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed']),
  "unknown_partners": zod.array(zod.string())
});

export type RefineProposalOut = zod.input<typeof RefineProposalOut>;
export type RefineProposalOutOutput = zod.output<typeof RefineProposalOut>;
